import * as React from "react";
import {SVGProps} from "react";

export const IconArrowRight = (props: SVGProps<SVGSVGElement>) => {
    const {color = "currentColor", width = "1em", height = "1em", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 42 42"
            fill="none"
            {...rest}
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3.506}
                d="M9.621 21.132h24.543M21.893 8.86l12.271 12.273-12.271 12.271"
            />
        </svg>
    );
};
